import { ScreenOrientation } from '@capacitor/screen-orientation'

import { OfficeRoutePath } from '@/RoutePath'

import { isNativePlatform } from './platform'

const WAREHOUSE_SCAN_PATHS = [
  OfficeRoutePath.ScanPickupOrders,
  OfficeRoutePath.BarcodeGunShip,
  OfficeRoutePath.ScanMe,
  OfficeRoutePath.PickupOrders,
]

export async function syncWarehouseOrientation(pathname: string): Promise<void> {
  if (!isNativePlatform()) return
  const shouldLockPortrait = WAREHOUSE_SCAN_PATHS.some(path => pathname === path || pathname.startsWith(`${path}/`))
  try {
    if (shouldLockPortrait) {
      await ScreenOrientation.lock({ orientation: 'portrait' })
      return
    }
    await ScreenOrientation.unlock()
  } catch {
    // Android 16+ large screens ignore orientation lock; simulators may lack the plugin.
  }
}
